export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_q01_a.24a8ff04.png";